// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"167":"b87a021f","213":"a5fa2b44","698":"4e159f5b","732":"e9003e69"}[chunkId] + ".js";
};